"use strict";

export function initInScope($scope) {
    $scope.find('.js-smoothscroll__link').on('click', function (evt) {
        evt.preventDefault();
        let offset = (matchMedia('(max-width: 767px)').matches ? 70: 100);
        let scrollElement = $(this).attr('href');

        $('html, body').animate({
            scrollTop: $(scrollElement).offset().top - offset
        }, 1000);

    });


    $scope.find('.js-smoothscroll__btn').on('click', function (evt) {
        let offset = (matchMedia('(max-width: 767px)').matches ? 70: 100);
        let scrollElement = $(this).attr('data-href');

        $('html, body').animate({
            scrollTop: $(scrollElement).offset().top - offset
        }, 1000);

    });
}